import { useQuery } from "@tanstack/react-query";

import { userProfileApi } from "api";
import { ApiQueryOptions } from "hooks/api/queryHelper";
import { transformToConsentsClass } from "models/userProfile/Consents";

const fetchConsents = async () => {
  const [error, response] = await userProfileApi.fetchConsents();

  if (error) {
    throw error;
  } else {
    return response;
  }
};

const useFetchConsents = (options: ApiQueryOptions = {}) => {
  return useQuery({
    queryKey: ["userProfile", "consents"],
    queryFn: () => fetchConsents(),
    select: (data) => transformToConsentsClass(data.consents),
    ...options,
  });
};

export default useFetchConsents;
